import { createContext } from 'react';
import { COURSE_STATUS_INPROGRESS, COURSE_STATUS_SCHEDULED, COURSE_TABLE_CATEGORY_COL, COURSE_TABLE_END_DATE_COL, COURSE_TABLE_IS_REGISTERED_COL, COURSE_TABLE_LANG_COL, COURSE_TABLE_NAME_COL, COURSE_TABLE_NUM_BOOKINGS_COL, COURSE_TABLE_START_DATE_COL, COURSE_TABLE_STATUS_COL, COURSE_TABLE_TEACHER_NAME_COL, SHOW_ALL } from '../i18n/keyConstants';
const selectedFilters = { name: '', teacherName: '', startDate: '', endDate: '', isRegistered: '', numBookings: '', status: '', format: '' };

const tableColumnExtensions = [
    { columnName: 'numBookings', width: 100, align: 'right' },
    { columnName: 'teacherName', width: 300, align: 'left' },
    { columnName: 'startDate', width: 150, align: 'left' },
    { columnName: 'endDate', width: 150, align: 'left' },
    { columnName: 'format', width: 120,}
];
const defaultColumns = [
    {
        title: COURSE_TABLE_NAME_COL,
        name: "name"
    },
    {
        title: COURSE_TABLE_LANG_COL,
        name: "language"
    },
    {
        title: COURSE_TABLE_START_DATE_COL,
        name: "startDate"
    },
    {
        title: COURSE_TABLE_END_DATE_COL,
        name: "endDate"
    },
    {
        title: COURSE_TABLE_NUM_BOOKINGS_COL,
        name: "numBookings"
    },
    {
        title: COURSE_TABLE_TEACHER_NAME_COL,
        name: "teacherName"
    },
    {
        title: COURSE_TABLE_STATUS_COL,
        name: "status"
    },
    {
        title: "Format",
        name: "format"
    },
    {
        title: COURSE_TABLE_CATEGORY_COL,
        name: "category"
    },
    {
        title: COURSE_TABLE_IS_REGISTERED_COL,
        name: "isRegistered"
    },
];

const defaultHiddenColumns = [];

export const initialState = {
    filters: [{columnName: 'status', operation: 'equal', value: "1OR2"}],
    selectedFilters: selectedFilters,
    defaultFilters: [{ columnName: 'status', operation: 'equal', value: "1OR2" }],
    selectedCourseStatus: [{ label: COURSE_STATUS_SCHEDULED, value: 1 }, { label: COURSE_STATUS_INPROGRESS, value: 2 }],
    selectedCourseCategory: [{ label: SHOW_ALL, value: null }],
    selectedCourseLanguage: [{ label: SHOW_ALL, value: null }],
    selectedIsRegisteredOption: [{ label: SHOW_ALL, value: '' }],
    selectedCourseFormat: [{ label: SHOW_ALL, value: null }],
    hiddenColumns: defaultHiddenColumns,
    tableSize: 0,
    pageSize: 25,
    currentPage: 1,
    direction: 'asc',
    sortInfo: {},
    columnName: 'startDate',
    columns: defaultColumns,
    isResettingFilters: false,
    selectedCourseStartDate: null,
    selectedCourseEndDate: null,
    tableColumnExtensions,
    courses: [],
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_SUCCESS':
            return {
                ...state,
                courses: action.courses,
                tableSize: action.totalRows,
            };
        case 'FILTERS':
            return {
                ...state,
                filters: action.payload,
                defaultFilters: action.payload,
                currentPage: 1,
            };
        case 'RESET_FILTERS':
            return {
                ...state,
                filters: [],
                defaultFilters: [],
                selectedCourseStatus: [{ label: '', value: null }],
                currentPage: 1,
                pageSize: 25,
                isResettingFilters: true,
                hiddenColumns: defaultHiddenColumns
            };
        case 'FILTERS_RESET':
            return {
                ...state,
                isResettingFilters: false,
            };
        case 'SELECTED_FILTERS':
            return {
                ...state,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.payload }),
            };
        case 'FILTERS_AND_SELECTED_FILTERS':
            return {
                ...state,
                filters: action.payload,
                defaultFilters: action.payload,
                currentPage: 1,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.columnNameVal }),
            };
        case 'PAGESIZE':
            return {
                ...state,
                pageSize: action.payload,
            };
        case 'CURRENT_PAGE':
            return {
                ...state,
                currentPage: action.payload,
            };
        case 'HIDDEN_COLUMNS_AND_CUSTOM_COLS':
            return {
                ...state,
                hiddenColumns: action.hiddenColumns,
                showCustomCols: action.showCustomCols,
            };
        case 'RESET_HIDDEN_COLUMNS':
            return {
                ...state,
                hiddenColumns: defaultHiddenColumns,
                showCustomCols: false,
            };
        case 'SELECTED_COURSE_STATUS':
            return {
                ...state,
                selectedCourseStatus: action.payload,
            };
        case 'SELECTED_COURSE_CATEGORY':
            return {
                ...state,
                selectedCourseCategory: action.payload,
            };
        case 'SELECTED_COURSE_LANGUAGE':
            return {
                ...state,
                selectedCourseLanguage: action.payload,
            };
        case 'SELECTED_ISREGISTERED_OPTION':
            return {
                ...state,
                selectedIsRegisteredOption: action.payload,
            };
        case 'SELECTED_COURSE_STARTDATE':
            return {
                ...state,
                selectedCourseStartDate: action.payload,
            };
        case 'SELECTED_COURSE_ENDDATE':
            return {
                ...state,
                selectedCourseEndDate: action.payload,
            };
        case 'SELECTED_FILTERS_AND_FILTERS_RESET':
            return {
                ...state,
                selectedFilters: Object.assign(selectedFilters, { [action.columnName]: action.payload }),
                isResettingFilters: false,
            };
        case 'SELECTED_COURSE_FORMAT':
            return {
                ...state,
                selectedCourseFormat: action.payload,
            };
        case 'SORT_INFO':
            return {
                ...state,
                sortInfo: action.sortInfo,
                columnName: action.columnName,
                direction: action.direction,
            };
        case 'SET_COLUMNS':
            return {
                ...state,
                columns: action.columns,
            };
        default:
            return state;
    }
};

export const DataContext = createContext(initialState);
